import React, { useState } from 'react';
import Card from '../Card/Card';
import CardBody from '../Card/CardBody';
import CardHeader from '../Card/CardHeader';
import { cardTitle } from '../../assets/jss/material-dashboard-pro-react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '../../components/CustomButtons/Button';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import CardIcon from '../Card/CardIcon';

import iconPlusSvg from 'assets/img/icons/plus.svg';
import iconMinusSvg from 'assets/img/icons/minus.svg';

const styles = {
  customCardContentClass: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  cardIconTitle: {
    ...cardTitle,
  },
  tileCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 15,
    marginBottom: 10,
    position: 'relative',
  },
  perfectScrollBarContainerLimited: {
    maxHeight: '80vh',
    marginRight: -10,
    paddingRight: 10,
    overflowX: 'hidden',
    '& .MuiTable-root': {
      margin: 0,
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
    },
  },
  collapseButton: {
    width: 50,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 20,
    zIndex: 3,
    cursor: 'pointer',
    color: '#999',
  },
  icon: {
    width: 20,
    height: 20,
    backgroundRepeat: 'none',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    display: 'inline-block',
    opacity: 0.3,
  },
  iconPlus: {
    backgroundImage: `url("${iconPlusSvg}")`,
  },
  iconMinus: {
    backgroundImage: `url("${iconMinusSvg}")`,
  },
  cardBody: {
    backgroundColor: '#ffffff',
    borderRadius: '0 0 8px 8px',
  },
};

const useStyles = makeStyles(styles);

export default function Tile(props) {
  let {
    title,
    titleButtonText,
    titleButtonFunc,
    titleButtonIcon,
    titleButtonComponent,
    titleButtonProps,
    titleButtons,
    children,
    maxHeightLimitByScreen,
    titleIcon,
    className,
    useCollapsing,
    initCollapsed,
    classNameHeader,
  } = props;
  const defaultTitleButtonProps = { color: 'primary', size: 'sm' };
  if (!titleButtonProps) titleButtonProps = defaultTitleButtonProps;
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(initCollapsed || false);

  return (
    <Card className={className}>
      {!!title || !!titleButtonText || !!titleIcon || !!titleButtons ? (
        <CardHeader icon className={classNameHeader}>
          {titleIcon ? <CardIcon color="primary">{titleIcon}</CardIcon> : ''}
          <div className={classes.tileCardHeader} style={{ margin: '15px 7px 15px 0px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {!!useCollapsing && (
                <div className={classes.collapseButton} onClick={() => setCollapsed(!collapsed)}>
                  {collapsed ? (
                    <div className={classes.icon + ' ' + classes.iconPlus} />
                  ) : (
                    <div className={classes.icon + ' ' + classes.iconMinus} />
                  )}
                </div>
              )}
              <h3 className={classes.cardIconTitle}>{title}</h3>
            </div>
            {(!!titleButtonText || !!titleButtonIcon) && (
              <Button {...titleButtonProps} onClick={titleButtonFunc}>
                <>
                  {titleButtonIcon ? titleButtonIcon : ''}
                  {titleButtonText ? titleButtonText : ''}
                </>
              </Button>
            )}
            {!!titleButtons && (
              <div className={classes.titleButtons}>
                {titleButtons.map((button, index) => {
                  const buttonProps = button.props ? button.props : defaultTitleButtonProps;
                  return (
                    <Button {...buttonProps} onClick={button.func} key={index}>
                      <>
                        {button.text ? button.text : ''}
                        {button.icon ? button.icon : ''}
                      </>
                    </Button>
                  );
                })}
              </div>
            )}
            {!!titleButtonComponent && titleButtonComponent}
          </div>
        </CardHeader>
      ) : (
        ''
      )}
      {!collapsed && (
        <CardBody style={{ overflowX: 'auto' }} className={classes.cardBody}>
          {maxHeightLimitByScreen ? (
            <PerfectScrollbar className={classes.perfectScrollBarContainerLimited}>{children}</PerfectScrollbar>
          ) : (
            <div>{children}</div>
          )}
        </CardBody>
      )}
    </Card>
  );
}
